/**
 * Animated Outlet Component
 *
 * Wrapper for React Router's Outlet that enables View Transitions API.
 * The view-transition-name CSS property creates a named transition layer
 * that animates between route changes.
 */

import { Outlet } from 'react-router-dom';

export function AnimatedOutlet() {
  return (
    <div className="view-transition-content h-full">
      <Outlet />
    </div>
  );
}
